import angular from 'angular';
import {AddAccountTrustpilotController} from './addAccountTrustpilot.controller.js';

angular.module('parameters.addAccountTrustpilot', [])
  .controller('AddAccountTrustpilotController', AddAccountTrustpilotController);
